import { useTranslation, Trans } from 'react-i18next';

// Components
import { Link } from 'components/destiny/button';

// Styles
import styles from './index.module.scss';

type FooterProps = {
  links: Array<{
    url: string;
    labelKey: string;
  }>;
};

const FooterPolicies = () => (
  <div className={styles.footerPolicies}>
    <div className={styles.footerCopyright}>
      <div>
        <Trans
          i18nKey="labels.footer.copyrightText"
          values={{ year: new Date().getFullYear() }}
        />
      </div>
    </div>
    <div className={styles.footerTrademark}>
      <div>
        <Trans
          i18nKey="labels.footer.legalText"
          components={[<sup>&reg;</sup>]}
        />
      </div>
    </div>
  </div>
);

export const Footer = ({ links }: FooterProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.footerWrapper}>
      <FooterPolicies />
      <nav className={styles.footerNav} aria-label="Footer">
        {links.map((link) => (
          <Link
            key={link.labelKey}
            href={link.url}
            className={styles.footerNavItem}
          >
            {t(link.labelKey)}
          </Link>
        ))}
      </nav>
      <FooterPolicies />
    </div>
  );
};
